// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { registerDecorator } from 'class-validator';
export function IsBeforeOrToday(validationOptions) {
    return function (object, propertyName) {
        registerDecorator({
            name: 'isBeforeOrToday',
            target: object.constructor,
            propertyName: propertyName,
            options: validationOptions,
            validator: {
                validate(propertyValue) {
                    return propertyValue.valueOf() <= Date.now().valueOf();
                },
                defaultMessage(args) {
                    return `"${args.property}" must be before or today`;
                }
            }
        });
    };
}
//# sourceMappingURL=isBeforeNow.js.map